import crudService from 'src/shared/services/crud/crudService';

export default crudService;
